/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RttrSerialVerifyRequest
 */
export interface RttrSerialVerifyRequest {
    /**
     * Minelab product serial as printed on the device or warranty card.
     * @type {string}
     * @memberof RttrSerialVerifyRequest
     */
    serialNumber: string;
}

/**
 * Check if a given object implements the RttrSerialVerifyRequest interface.
 */
export function instanceOfRttrSerialVerifyRequest(value: object): value is RttrSerialVerifyRequest {
    if (!('serialNumber' in value) || value['serialNumber'] === undefined) return false;
    return true;
}

export function RttrSerialVerifyRequestFromJSON(json: any): RttrSerialVerifyRequest {
    return RttrSerialVerifyRequestFromJSONTyped(json, false);
}

export function RttrSerialVerifyRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RttrSerialVerifyRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'serialNumber': json['serialNumber'],
    };
}

export function RttrSerialVerifyRequestToJSON(json: any): RttrSerialVerifyRequest {
    return RttrSerialVerifyRequestToJSONTyped(json, false);
}

export function RttrSerialVerifyRequestToJSONTyped(value?: RttrSerialVerifyRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'serialNumber': value['serialNumber'],
    };
}

